// Import controller interfaces
import {
    IDocumentController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    PossibleDocCategory,
    DocResponse,
} from '@app/models/api';

export default class MockDocumentController implements IDocumentController {

    public constructor() {
        
    }

    public async getPossibleDocCategories(): Promise<PossibleDocCategory[]> {
        let possibleDocCategory1: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory1.code = 'Mortgagee Correspondence';
        possibleDocCategory1.displayName = 'Mortgagee Correspondence';
        possibleDocCategory1.isYearRequired = false;

        let possibleDocCategory2: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory2.code = 'Producer Correspondence';
        possibleDocCategory2.displayName = 'Producer Correspondence';
        possibleDocCategory2.isYearRequired = false;

        let possibleDocCategory3: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory3.code = 'Insured Correspondence';
        possibleDocCategory3.displayName = 'Insured Correspondence';
        possibleDocCategory3.isYearRequired = false;

        let possibleDocCategory4: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory4.code = 'Photos';
        possibleDocCategory4.displayName = 'Photos';
        possibleDocCategory4.isYearRequired = false;

        let possibleDocCategory5: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory5.code = 'Cancelation Request';
        possibleDocCategory5.displayName = 'Cancelation Request';
        possibleDocCategory5.isYearRequired = false;

        let possibleDocCategory7: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory7.code = 'Miscellaneous';
        possibleDocCategory7.displayName = 'Miscellaneous';
        possibleDocCategory7.isYearRequired = false;

        let possibleDocCategory8: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory8.code = 'Letter of no Loss';
        possibleDocCategory8.displayName = 'Letter of no Loss';
        possibleDocCategory8.isYearRequired = false;

        let possibleDocCategory9: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory9.code = 'Elevation Certificate';
        possibleDocCategory9.displayName = 'Elevation Certificate';
        possibleDocCategory9.isYearRequired = false;

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve([
                    possibleDocCategory1,
                    possibleDocCategory2,
                    possibleDocCategory3,
                    possibleDocCategory4,
                    possibleDocCategory5,
                    possibleDocCategory7,
                    possibleDocCategory8,
                    possibleDocCategory9,
                ]);
            }, 1000);
        });
    }

    public async getPossibleDocCategoriesAdmin(): Promise<PossibleDocCategory[]> {
        let possibleDocCategory1: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory1.code = 'Mortgagee Correspondence';
        possibleDocCategory1.displayName = 'Mortgagee Correspondence';
        possibleDocCategory1.isYearRequired = false;

        let possibleDocCategory2: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory2.code = 'Producer Correspondence';
        possibleDocCategory2.displayName = 'Producer Correspondence';
        possibleDocCategory2.isYearRequired = false;

        let possibleDocCategory3: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory3.code = 'Insured Correspondence';
        possibleDocCategory3.displayName = 'Insured Correspondence';
        possibleDocCategory3.isYearRequired = false;

        let possibleDocCategory4: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory4.code = 'Photos';
        possibleDocCategory4.displayName = 'Photos';
        possibleDocCategory4.isYearRequired = false;

        let possibleDocCategory5: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory5.code = 'Cancelation Request';
        possibleDocCategory5.displayName = 'Cancelation Request';
        possibleDocCategory5.isYearRequired = false;

        let possibleDocCategory6: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory6.code = 'Diligent Search Statement';
        possibleDocCategory6.displayName = 'Diligent Search Statement';
        possibleDocCategory6.isYearRequired = true;

        let possibleDocCategory7: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory7.code = 'Miscellaneous';
        possibleDocCategory7.displayName = 'Miscellaneous';
        possibleDocCategory7.isYearRequired = false;

        let possibleDocCategory8: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory8.code = 'Letter of no Loss';
        possibleDocCategory8.displayName = 'Letter of no Loss';
        possibleDocCategory8.isYearRequired = false;

        let possibleDocCategory9: PossibleDocCategory = new PossibleDocCategory();
        possibleDocCategory9.code = 'Elevation Certificate';
        possibleDocCategory9.displayName = 'Elevation Certificate';
        possibleDocCategory9.isYearRequired = false;

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve([
                    possibleDocCategory1,
                    possibleDocCategory2,
                    possibleDocCategory3,
                    possibleDocCategory4,
                    possibleDocCategory5,
                    possibleDocCategory6,
                    possibleDocCategory7,
                    possibleDocCategory8,
                    possibleDocCategory9,
                ]);
            }, 1000);
        });
    }

    public async getPolicyPackets(policyId: number, zipCode: string): Promise<DocResponse[]> {
        throw new Error("Method not implemented.");
    }
};